import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIMenuItemComponent } from './ui-menu-item.component';

@NgModule({
  declarations: [UIMenuItemComponent],
  exports: [UIMenuItemComponent],
  imports: [
    CommonModule,
    IonicModule
  ]
})
export class UIMenuItemModule { }
